import {Spin, Empty, Divider, Button} from 'antd';
import React from 'react';

import {isCampaignRetention} from '../../utils';

import {InfoIcon} from '../';
import {mapRawStatsToItems, mapRawStatsToErrors} from './audienceUtils';

export const PopoverContent = ({stats, campaign, isAdmin, loading, potential, onStatsClick}: any) => {
  if (loading) {
    return (
      <div className="audience-stats__popover">
        <Spin size="large" tip="Loading..." />
      </div>
    )
  }
  if (!stats?.length) {
    return (
      <div className="audience-stats__popover">
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            isCampaignRetention(campaign)
              ? 'This campaign has no specific data about potential. Please enable campaign (ON) and we’ll gather data the next time that it will run.'
              : 'This campaign has no specific data about potential. Please enable Invites (I) and we’ll gather data the next time that it will run.'
          }
        />
      </div>
    )
  }
  const items = mapRawStatsToItems(stats, campaign);
  const errorItems = mapRawStatsToErrors(stats, campaign);
  return (
    <div className="audience-stats__popover">
      <div className="audience-stats__items-container">
        <span>{`potential: ${potential}`}</span>
        {/* <span className="audience-stats__potential-divider">{' • '}</span>
        <span>{`reach: ${reach}`}</span> */}
      </div>
      <div className="audience-stats__progress-line">
        {items.map(val => (
          <span
            key={val.label}
            style={{
              backgroundColor: val.color,
              flexGrow: val.total,
            }}
          />
        ))}
      </div>
      <div className="audience-stats__items-container">
        {items.map(val => (
          <span key={val.label} className="audience-stats__item-container">
            <span
              className="audience-stats__color-circle"
              style={{
                background: val.color,
              }}
            />
            <span style={{marginLeft: 5, ...val.styles}}>
              {val.details && (
                <Button
                  type="link"
                  className="audience-stats__status-details-button"
                  onClick={() => onStatsClick(val.status, campaign.id)}
                >
                  {val.label}
                </Button>
              )}
              {!val.details && val.label}
              {val.tooltip && <InfoIcon message={val.tooltip} />}{' '}
              <span className="audience-stats__item-total">{val.total}</span>
            </span>
          </span>
        ))}
      </div>
      {isAdmin && !!errorItems?.length && (
        <>
          <Divider className="audience-stats__errors-divider" orientation="left">
            Errors
          </Divider>
          <div className="audience-stats__items-container">
            {errorItems.map(val => (
              <span key={val.label} className="audience-stats__item-container">
                <span
                  className="audience-stats__color-circle"
                  style={{
                    background: val.color,
                  }}
                />
                <span style={{marginLeft: 5, ...val.styles}}>
                  {val.label} <span className="audience-stats__item-total">{`${val.total}`}</span>
                </span>
              </span>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
